module.exports = __webpack_public_path__ + "static/img/pic_ADorg@2x.5024306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_template/pic_ADorg@2x.png
// module id = ZiKA
// module chunks = 0